export default "__VITE_ASSET__B4ElLL4F__"